import React, {useEffect, useState} from 'react';
import EMDBcart from  '../../utils/emdb.cart.js'

//ICONS
import cartimg from "./assets/cart-black.webp";

//CSS
import styles from './VTCartIcon.module.less';

function VTCartIcon({icon, showprice= true}) {
  const cart = new EMDBcart('vtformcart');
  const iconcart = icon != undefined ? icon: cartimg;
  const [numProducts, setNumProducts] = useState(cart.getNumProducts ());

  useEffect(() => {
  //Comprobamos evento Storage para saber si se actualizo el carro
    const handleStorage = () => {
      //Actualizamos el objeto con el carro
      cart.refreshCart();
      setNumProducts(cart.getNumProducts ());
    }

    document.addEventListener('storage', handleStorage)
    return () => document.removeEventListener('storage', handleStorage)
  }, [])

  return (
      <div className={styles.vtcarticon}>
        <img className={styles.cartImg} src={iconcart}/>
        <div className={styles.numProducts}>{numProducts}</div>
        {showprice && <span className={styles.price}>{cart.getCartAmount ()} &euro;</span>}
      </div>
  );
}
export default VTCartIcon;
